import { flatten } from "../../flatten";
/**
 * Validates that a computed value is not greater than a maximum value.
 */
export const Validator = {
    name: "max_computation",
    isImplicit: true,
    errorMessage: "Max computation value exceeded :max_computation.",
    validate: function (value, requirement) {
        const [maxComputationField, maxComputationValue] = requirement.split(",");
        const val = flatten(this.validator.input)[maxComputationField];
        return Number(val) <= Number(maxComputationValue);
    },
};
